import {
  Popper,
  PopperProps,
  Tab,
  Tabs,
  autocompleteClasses,
  styled as styledComponent,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import { styled, Box } from "@mui/system";
import { StyledComponent } from "@emotion/styled";
import { FaCheckCircle, FaExclamationCircle } from "react-icons/fa";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";

import { colors, others } from "../../../styles/colors";
import fontWeight from "../../../styles/mui/fontWeight";

export const TabsPanelSectionBox = styled(Box)(() => ({
  boxShadow: `1px 1px 8px ${colors.dropShadow[4]}`,
  backgroundColor: colors.white[1],
  borderRadius: "10px",
  marginBottom: "1rem"
}));

export const PanelBox = styled(Box)(() => ({
  padding: "1.2rem 0.5rem 0 0.7rem",
}));

export const PatientHeaderTabs = styled(Tabs)(() => ({
  overflow: "visible",
  "& .MuiTabs-scroller": {
    overflow: "visible",
  },
  marginLeft: "2rem",
  "& .MuiTabs-indicator": {
    backgroundColor: "unset",
  },
  "& .Mui-selected": {
    border: `1px solid ${colors.borders[1]}`,
    color: colors.fonts[18],
    fontSize: ".75rem",
    fontWeight: fontWeight.Weight[6],
    opacity: 1,
    textTransform: "uppercase",
    borderBottom: `1px solid ${colors.white[1]}`,
  },
  "& .MuiTabs-flexContainer": {
    paddingTop: "20px",
  },
}));

export const PatientHeaderTab = styled(Tab)(() => ({
  backgroundColor: colors.white[1],
  marginRight: "1rem",
  borderBottomRightRadius: "0px",
  borderBottomLeftRadius: "0px",
  border: `1px solid ${colors.borders[1]}`,
  boxShadow: `1px 1px 8px ${colors.dropShadow[4]}`,
  textTransform: "uppercase",
  overflow: "visible",
  color: colors.fonts[19],
  padding: "0.7rem 0.5rem 0.2rem 0.5rem",
  minHeight: "2.45rem",
  fontSize: ".75rem",
  fontWeight: fontWeight.Weight[3],
  opacity: 0.9,
  width: "10.3rem",
}));

export const ReferralGrid = () => ({
  display: "block",
});

export const DetailBox: any = styled(Grid)(() => ({
  backgroundColor: colors.backgroundColor[14],
  padding: "0 1.5rem",
  left: 0,
  right: 0,
  overflow: "hidden",
}));

export const width100PCT = () => ({
  width: "100%",
});

export const FormInputBox = {
  padding: "1rem 3rem 1rem 0",
};

export const OuterGrid = () => ({
  background: others.otherColors[75],
  height: "calc(100vh - 3rem)",
  padding:"2rem 4rem 2rem 4rem"
}); 

export const TopGrid = () => ({
  display: "flex",
  justifyContent: "center",
  textTransform: "uppercase",
  padding: "0.7rem",
});

export const GridBody = () => ({
  background: others.otherColors[33],
  boxShadow: `0.0487rem 0.15rem 0.78rem ${colors.dropShadow[4]}`,
  opacity: 1,
  padding: "1.2rem 1.6rem 1.5rem 1.5rem",
  marginBottom: "0.8rem",
  borderRadius: "0.5rem",
  display: "flex",
});

export const EligibilityCheckGridBody = () => ({
  background: others.otherColors[33],
  boxShadow: `0.0487rem 0.15rem 0.78rem ${colors.dropShadow[4]}`,
  opacity: 1,
  padding: "1.2rem 1.6rem 0rem 1.5rem",
  borderRadius: "0.5rem",
  display: "flex",
});

export const HorizontalDivider = () => ({
  margin: "1rem 0",
  minWidth: "100%",
  width: "95%",
});

export const AutoComplete = {
  width: "12.5rem",
  minWidth: "7rem",
  maxWidth: "20rem",
  "& .MuiAutocomplete-inputRoot": {
    paddingLeft: 0,
  },
};

export const Search = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
};

export const StyledPopperCheckBoxAutocomplete: StyledComponent<PopperProps> =
  styledComponent(Popper)({
    [`& .${autocompleteClasses.listbox}`]: {
      boxSizing: "border-box",
      "& ul": {
        margin: "2rem",
      },
      "& .MuiAutocomplete-option": {
        cursor: "pointer",
      },
      "&::-webkit-scrollbar": {
        width: ".25rem",
        height: "0.3rem",
        paddingLeft: "2rem",
      },
      "&::-webkit-scrollbar-track": {
        width: 0.4,
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: colors.black[6],
        borderRadius: 0.5,
        width: 0.3,
      },
    },
  });

export const ButtonGrid = () => ({
  display: "flex",
  justifyContent: "flex-end",
  alignItem: "flex-end",
  marginTop: "0.5rem",
});

export const EligibilityButtonGrid = () => ({
  display: "flex",
  justifyContent: "flex-end",
  alignItem: "flex-end",
});

export const ButtonStyle = () => ({
  textTransform: "capitalize",
});

export const FaCheckCircleIcon = styled(FaCheckCircle)(() => ({
  color: colors.brand.secondary,
  fontSize: "1rem",
}));

export const HeaderTitle = () => ({
  paddingTop: "0.2rem",
  paddingLeft: "1rem",
});

export const GridContainerField = () => ({
  padding: "2rem 0rem",
});

export const FaExclamationCircleIcon = styled(FaExclamationCircle)(() => ({
  color: colors.red[100],
  fontSize: "1rem",
}));
export const DocGridBody = () => ({
  background: colors.backgroundColor[9],
  boxShadow: `1px 1px 8px ${colors.dropShadow[4]}`,
  opacity: 1,
  padding: "1.5rem 1.5rem 2rem 2rem",
  marginBottom: "0.8rem",
  paddingBottom: "2.5rem",
  borderRadius: "0.8rem",
  margin: "0rem 2rem 2rem 2rem",
});

export const ListItemStyle = {
  minWidth: "1.2rem",
};

export const FiberManualRecordIconStyle: any = styled(FiberManualRecordIcon)(
  () => ({
    width: "0.7rem",
    height: "0.7rem",
  })
);

export const confirmationDialogBox = () => ({
  "& .MuiDialog-paper": {
    height: "10rem",
    justifyContent: "center",
    borderRadius: "1.5rem",
    maxWidth: "28rem",
    alignItems: "center",
    textAlign: "center",
  },
});

export const DocumentTypeIcon = () => ({
  color: colors.fonts[18],
  padding: "0 0.5rem 0 0.8rem",
});

export const DividerStyle = {
  height: "1.5rem",
  borderRightWidth: "0.15rem",
  paddingLeft: "1rem",
};

export const DocFlexRow = () => ({
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
});
export const CancelButtonGrid = () => ({
  margin: "1rem 0",
  display: "flex",
  alignItems: "center",
  justifyContent: "start",
});

export const NextButtonGrid = () => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "end",
  margin: "1rem 0",
});

export const ButtonMinWidth = () => ({
 minWidth: "7rem"
});

export const BcbsGridBody = () => ({
  background: others.otherColors[33],
  boxShadow: `0.0487rem 0.15rem 0.78rem ${colors.dropShadow[4]}`,
  opacity: 1,
  padding: "0.5rem 0.5rem 0.5rem 0.5rem",
  borderRadius: "0.5rem",
  display: "flex",
  alignItems: "center",
});

export const MainTitle = () => ({
  paddingTop: "0.4rem",
  paddingLeft: "1rem",
});